if (!customElements.get("junie-stock-status")) {
  customElements.define(
    "junie-stock-status",
    class JunieStockStatus extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) || 15;
        this.stock = this.querySelector("[data-junie-stock]");
        this.stockTrack = this.querySelector("[data-junie-stock-track]");
        this.stockFill = this.querySelector("[data-junie-stock-fill]");
        this.stockLabel = this.querySelector("[data-junie-stock-label]");
        this.limitedAvailability =
          this.dataset.limitedLabel || "Limited availability";

        const inventoryNode = this.querySelector("[data-junie-inventory]");
        this.inventory = inventoryNode
          ? JSON.parse(inventoryNode.textContent)
          : [];

        this.onVariantChanged = this.onVariantChanged.bind(this);
        document.addEventListener("variant:changed", this.onVariantChanged);
      }

      disconnectedCallback() {
        document.removeEventListener("variant:changed", this.onVariantChanged);
      }

      onVariantChanged(event) {
        const variant = event.detail?.variant;
        if (!variant) return;

        const inventory = this.inventory.find(
          (item) => Number(item.id) === Number(variant.id),
        );
        if (inventory) this.update(inventory);
      }

      update(inventory) {
        this.updateStock(inventory);
      }

      updateStock(inventory) {
        if (!inventory.available) {
          this.stock.classList.add("is-hidden");
          return;
        }

        this.stock.classList.remove("is-hidden");
        const showCount =
          inventory.tracked &&
          !inventory.continueSelling &&
          inventory.quantity > 0 &&
          inventory.quantity <= this.threshold;

        if (showCount) {
          const percent = Math.min(
            100,
            (inventory.quantity / this.threshold) * 100,
          );
          this.stockTrack.classList.remove("is-hidden");
          this.setFill(percent);
          this.stockLabel.innerHTML = inventory.stockLabel;
          return;
        }

        if (inventory.tracked) {
          this.stock.classList.add("is-hidden");
          return;
        }

        this.stockTrack.classList.remove("is-hidden");
        this.setFill(55);
        this.stockLabel.textContent = this.limitedAvailability;
      }

      setFill(percent) {
        this.stockFill.style.setProperty(
          "--junie-stock-pct",
          `${percent}%`,
        );
        this.stockFill.style.setProperty(
          "--junie-stock-start",
          `${Math.min(100, percent + 18)}%`,
        );
        this.stockFill.classList.remove("is-animated");
        void this.stockFill.offsetWidth;
        this.stockFill.classList.add("is-animated");
      }
    },
  );
}
